export default __webpack_public_path__ + "static/media/gear.45de430d.svg";